import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { BlockFactory } from '../../../blockly/BlockFactory';
import { backToBlocklyPage } from "../functional/backToBlocklyPage";
import { useRoute, useRouter } from 'vue-router';

interface Prop{
  assetPath:string
  isVrm:boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModelVrmButton',
  props: {
    assetPath: null,
    isVrm: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  assetPath:string
  isVrm:boolean;
};


const route = useRoute();
const router = useRouter();

const addVRMElement = (): void => {
  const factory = new BlockFactory();
  const vrm = factory.getVRMModel(props.assetPath);
  factory.addWorkspaceAfterMounted(vrm);
  MessageDialog.info(`VRM 3Dモデルブロックを追加しました`);
  backToBlocklyPage(route,router);
};


return (_ctx: any,_cache: any) => {
  return (__props.isVrm)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-outline-dark",
        onClick: addVRMElement
      }, " VRM "))
    : _createCommentVNode("", true)
}
}

})